import React, {FC, useCallback, useState} from "react";
import {
    IAssessmentTemplateGroup,
    IControlMeasure,
    IControlMeasureAssessment, IDataGap,
    IDocument,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, TextField,
    Typography
} from "@material-ui/core";


import DialogContentText from "@material-ui/core/DialogContentText";
import Documents from "./documents";

interface IInvestigationProps {
    datagap: IDataGap
    updateDataGap: (investigation: IDataGap) => void;
    closeDialogCallback: () => void;

}

const AddDataGapDialog: FC<IInvestigationProps> = ({
                                                             datagap,
                                                             closeDialogCallback,
                                                       updateDataGap}) => {

    const [newInvestigation, setNewInvestigation]= useState<IDataGap>(datagap);



    const renderField = <T,>(obj: T, key: keyof T,
                             label: string,
                             type: string,
                             setObj:(obj:T) => void) => {
        return <div>
            <div style={{
                width:"100%",
                margin:"auto",
            }}>
                <TextField
                    fullWidth
                    label={label}
                    value={obj[key]}
                    onChange={(event) => {
                        let v = (event.target.value as string);

                        let c = {...obj} as T;
                        if (type === "string") {
                            (c as any)[key] = v
                        }
                        if (type === "number") {
                            (c as any)[key] = parseFloat(v)
                        }
                        setObj(c)
                    }
                    }
                    type={type}
                />
            </div>
        </div>
    }



    const submitControlMeasure = () => {
        let ra = {...newInvestigation}
        updateDataGap(ra)
        closeDialogCallback()
    }



    return (  <Dialog open={true} onClose={closeDialogCallback} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Add Control Measure</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Add Control Measure
                </DialogContentText>
                {renderField<IDataGap>(newInvestigation,
                    "name",
                    "Data Gap",
                    "string", setNewInvestigation)}

            </DialogContent>
            <DialogActions>
                <Button onClick={closeDialogCallback} color="primary">
                    Cancel
                </Button>
                <Button onClick={submitControlMeasure} color="primary">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddDataGapDialog;
